import React, { ReactNode } from 'react';
import { Box, Types } from '@fiverr-private/theme';
import { FORM_LABEL_ID } from '../../constants';

interface FormLabelProps extends Pick<Types.BoxType, 'htmlFor' | 'dataTrackTag' | 'dataTrackValue'> {
  children: ReactNode;
}

const FormLabel = ({ children, htmlFor, dataTrackTag = 'form_label', dataTrackValue }: FormLabelProps) => (
  <Box
    dataTrackTag={dataTrackTag}
    dataTrackValue={dataTrackValue}
    as="label"
    color="grey_1200"
    lineHeight="b_md"
    fontSize="b_md"
    htmlFor={htmlFor}
  >
    {children}
  </Box>
);

FormLabel.id = FORM_LABEL_ID;
FormLabel.displayName = FORM_LABEL_ID;

export default FormLabel;
